import DataService from "../../../services/client/classes/dataService";
import { ISettingsCardAddEditOutput } from "../models/interfaces/memberInteriorSettings/iSettingsCardAddEditOutput";
import { IUpdatedPasswordOutput } from "../models/interfaces/memberInteriorSettings/iUpdatedPasswordOutput";
import { IPasswordEditOutput } from "../models/interfaces/memberInteriorSettings/iPasswordEditOutput";
import { IAccountIntegrationOutputData } from "../models/interfaces/memberInteriorSettings/iAccountIntegrationOutputData";

class MemberInteriorSettingsService extends DataService {
  constructor() {
    super('/private/database/memberInteriorSettings/');
  }

  getMemberInteriorSettingsData(): JQuery.jqXHR<any> {
    return this.get('interiorSettingsData/');
  }

    updateInteriorSettingsData(settingsCardAddEditOutput: ISettingsCardAddEditOutput): JQuery.jqXHR<any> {
        return this.post('updateInteriorSettingsData/', settingsCardAddEditOutput);
  }

    updateMemberPassword(updatedPasswordOutput: IUpdatedPasswordOutput): JQuery.jqXHR<any> {
        return this.post('updateMemberPassword/', updatedPasswordOutput);
  }

    updateEmailNotifications(passwordEditOutput: IPasswordEditOutput[]): JQuery.jqXHR<any> {
        return this.post('updateEmailNotifications/', passwordEditOutput);
    }

    updateMemberDataThroughLinkedIn(accountIntegrationOutputData: IAccountIntegrationOutputData): JQuery.jqXHR<any> {
        return this.post('updateMemberDataThroughLinkedIn/', accountIntegrationOutputData);
    } 
}

export default new MemberInteriorSettingsService();


// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/memberInteriorSettingsService.ts